import packMachineDetail from './packMachineDetail'
import packProjectDetail from './packProjectDetail'
import packRentDetail from './packRentDetail'

export default {
  namespaced: true,
  modules: {
    packMachineDetail,
    packProjectDetail,
    packRentDetail,
  },
}
